import { erpAxios } from '.';

const getDailyEventsByUser = async (emp) => {
  const { data } = await erpAxios(`/gpsDogadjaji/daily-by-user`, { params: { emp } });
  return data;
};

export default getDailyEventsByUser;
